import React from 'react';

const ProductIcons = ({ Icons }) => {
  if (!Icons || Icons.length === 0) return null;

  return (
    <ul className="product-icons">
      {Icons.map((icon, index) => (
        <li key={index}>
          <img src={icon.url} alt={icon.description || ''}/>
        </li>
      ))}
    </ul>
  );
};

export default ProductIcons;
